export const getErrorEvent = ({ config, data }, fallback) => ({
  key: config && (config.method + config.url),
  error: (data && data.error_message) || fallback,
  type: data && data.error
})

export const decorateErrorMessage = (error, verbed) => ([
  error.config.method.toUpperCase(),
  error.config.url.replace(error.config.baseURL, ''),
  verbed
].join(' '))
